var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-value"},[_c('span',{staticClass:"label-value-label has-text-weight-bold"},[_vm._v(_vm._s(_vm._f("uppercaseFirstLetter")(_vm.label)))]),_vm._v(" "),_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }